export default __webpack_public_path__ + "static/media/android-icon.67061b0f.svg";